import { render, staticRenderFns } from "./image-popup.vue?vue&type=template&id=d166928e&"
import script from "./image-popup.vue?vue&type=script&lang=js&"
export * from "./image-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports